<template>
  <div
    class="ms-icon-default flex items-center justify-center"
    v-if="!tooltipContent"
    :style="{background: bg}"
    :class="[`ms-icon-${color}`, {'round':round}]"
  >
    <i
      :style="iconStyle"
      :class="[icon]"
      v-bind="$attrs"
      class="ms-icon notranslate icon-scale"
      v-on="$listeners"
    >
      <slot></slot>
    </i>
  </div>

  <div
    class="ms-icon-container flex items-center justify-center"
    :class="[`ms-icon-${color}`, {'round':round}, `btn-icon-${typeBtnIcon}`]"
    :style="{background: bg}"
    v-bind="$attrs"
    v-on="$listeners"
    v-else
  >
    <MsTooltip position="bottom">
      <i :style="iconStyle" :class="[icon]" class="ms-icon notranslate icon-scale">
        <slot></slot>
      </i>
      <template v-slot:text>
        <div>{{tooltipContent}}</div>
      </template>
    </MsTooltip>
  </div>
</template>
<script>
import _color from "../../../components/controls/color";
import MsTooltip from "../../../components/controls/ms-tooltip/MsTooltip"
export default {
  name: "MsIcon",
  components: {
    MsTooltip
  },
  props: {
    bg: {
      type: String
    },
    icon: {
      default: null,
      type: String
    },
    color: {
      default: "",
      type: String
    },
    iconBg: {
      default: null,
      type: String
    },
    round: {
      default: false,
      type: Boolean
    },
    tooltipContent: {
      type: String,
      default: ""
    },
    // kiểu icon: 1-nền trắng, 2-nền xám, 3-nền xanh
    typeBtnIcon:{
      type: Number,
      default: 1
    }
  },
  computed: {
    iconStyle() {
      const style = {
        background: this.iconBg + ' !important'
      };
      return style;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/controls/_variables.scss";
i {
  display: block;
}
</style>

